
import React, { Component } from 'react'

const withBodyScrollDisabled = ComposedComponent => class extends Component {
  render () {
    return <ComposedComponent {...this.props} />
  }

  componentDidMount () {
    document.body.style.overflow = 'hidden'
  }

  componentWillUnmount () {
    document.body.style.overflow = null
  }
}

withBodyScrollDisabled.displayName = 'withBodyScrollDisabled'

export default withBodyScrollDisabled



// WEBPACK FOOTER //
// ./ui/withBodyScrollDisabled.js